import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div>
      {value === index && (
        <Box p={2.5}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}


const AntTabs = withStyles({
  root: {
    borderBottom: '1px solid #e8e8e8',
  },
  indicator: {
    backgroundColor: '#FF5252',
  },
})(Tabs);

const AntTab = withStyles((theme) => ({
  root: {
    textTransform: 'none',
    minWidth: 72,
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(4),
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:hover': {
      color: '#FF5252',
      opacity: 1,
    },
    '&$selected': {
      color: '#FF5252',
      fontWeight: theme.typography.fontWeightMedium,
    },
    '&:focus': {
      color: '#FF5252',
    },
  },
  selected: {},
}))((props) => <Tab disableRipple {...props} />);

function Delivery() {
  return (
    <div>
      <h3>1. Delivery Orders</h3>
      <ul style={{ lineHeight: 1.8 }}>
        <p>Delivery orders are accepted if the following criteria are met:</p>
        <li>The customer's delivery location falls within the permitted delivery zone of the designated Sanvika Foodzo outlet.</li>
        <li>The delivery address being mapped to the outlet that delivers in the customer's delivery location.</li>
        <li>Online availability of the outlet to accept and process the order.</li>
        <li>In the event, the customer's delivery location is not listed within the permitted delivery zone of the outlet, the order cannot be placed. However, you may choose to pick up your order from the permitted delivery zone.</li>
      </ul>
      <Divider />
      <h3>2. Menu</h3>
      <ul style={{ lineHeight: 1.8 }}>
        <li>The menu is displayed as per the availability of the menu items in the outlet.</li>
        <li>In case of non-availability of ordered menu items at the outlet, the order will not be executed and will be duly informed to the customer.</li>
      </ul>
      <Divider />
      <h3>3. Terms & Conditions for all coupons including printed, mobile and email coupons</h3>
      <ul style={{ lineHeight: 1.8 }}>
        <p>The customer may only use the coupon codes mentioned in any of Sanvika Foodzo's print material, promotional emails & SMS messages for placing an order via the Sanvika Foodzo App</p>
        <li>The complete and accurate coupon code must be entered in the coupon section on the payment page before completing the transaction, in order to avail the discount.</li>
        <li>The coupon code is case sensitive. It should only be entered in UPPERCASE.</li>
        <li>The coupon code may not work if the conditions defined in the coupon T&C are not met in the order.</li>
        <li>Sanvika Foodzo holds the right to accept or reject any coupon without giving any reason whatsoever.</li>
        <li>All coupons carry a validity period, mentioned in the coupon T&C and will not be accepted after the expiry of the validity period.</li>
        <li>A coupon/promotion cannot be clubbed with any other offer or scheme.</li>
        <li>Only one coupon is valid per order.</li>
        <li>Coupons are only valid on the Sanvika Foodzo mobile app.</li>
        <li>The customer must announce the coupon code while placing the order.</li>
      </ul>
      <Divider />
      <h3>4. Modify/Cancel the online order</h3>
      <ul style={{ lineHeight: 1.8 }}>
        <li>Orders once placed cannot be modified or cancelled either online or by the call centre.</li>
        <li>If the customer wishes to check on the progress of the order, they may do so by checking 'Current Orders' section of the App or by calling the outlet directly.</li>
        <li>In the event an order which is paid via credit card is cancelled due to non-availability of the ordered product, the amount will be reversed back to the customer. The transaction will reflect in the next month statement.</li>
        <li>Food from Sanvika Foodzo is for immediate consumption only (within 45 minutes from time of delivery).</li>
      </ul>
      <Divider />
    </div>
  );
}

function Policy() {
  return (
    <div>
      <h3>1. Privacy Policy</h3>
      <ul style={{ lineHeight: 1.8 }}>
        <li>A customer has the right to explore the Sanvika Foodzo App without supplying personal identifiable information.</li>
        <li>Sanvika Foodzo reserves the right to collect personal information from the customer including and not limited to first and last name, telephone & mobile numbers, email address, delivery address and any other information voluntarily provided by the customer.</li>
        <p><strong>This information is collected in the event a customer</strong></p>
        <li>Places an order.</li>
        <li>Enters a contest or promotional activity.</li>
        <li>Submits feedback.</li>
      </ul>
      <Divider />
      <h3>2. Use and Disclosure</h3>
      <ul style={{ lineHeight: 1.8 }}>
        <li>Apart from the events mentioned above, Sanvika Foodzo may use the personal information collected to improve the content of the website/app, customize the website/app to the customer's preferences, communicate information to the customer, and for any other specified purposes.</li>
        <li>Sanvika Foodzo may also store and process the personal information collected in order to provide goods and services.</li>
        <p><strong>The personal information is used in accordance to the customers benefit, including but not limited to any of the following purposes.</strong></p>
        <li>Provide the customer with outlet or promotion information.</li>
        <li>Process an online order placed by the customer.</li>
        <li>Submits feedback.</li>
      </ul>
      <Divider />
      <h3>3. Online Payments</h3>
      <ul style={{ lineHeight: 1.8 }}>
        <p>
          We use Razorpay for processing Online Payments. We/Razorpay do not store your card data on their servers. The data is encrypted through the Payment Card Industry Data Security Standard (PCI-DSS) when processing payment. Your purchase transaction data is only used as long as is necessary to complete your purchase transaction. After that is complete, your purchase transaction information is not saved.
          <br/><br/>
          Our payment gateway adheres to the standards set by PCI-DSS as managed by the PCI Security Standards Council, which is a joint effort of brands like Visa, MasterCard, American Express and Discover.
          <br/><br/>
          PCI-DSS requirements help ensure the secure handling of credit card information by our store and its service providers.
          <br/>
          For more insight, you may also want to read terms and conditions of razorpay on <a href="https://razorpay.com">https://razorpay.com</a>
          </p>
      </ul>
      <Divider />
    </div>
  );
}

export default function Privacy() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div>
        <AntTabs value={value} onChange={handleChange} aria-label="simple tabs example">
          <AntTab label="Terms and Conditions" {...a11yProps(0)} />
          <AntTab label="Privacy Policies" {...a11yProps(1)} />
        </AntTabs>
      <TabPanel value={value} index={0}>
        <Delivery></Delivery>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Policy></Policy>
      </TabPanel>
    </div>
  );
}